import { RegisterOptions, FieldValues } from 'react-hook-form';

const NAME_MIN_LENGTH = 2;

export function nameValidation<TFieldValues extends FieldValues = FieldValues>(
  minLengthMessage: string
): { validate: RegisterOptions<TFieldValues>['validate'] } {
  return {
    validate: (value: string): boolean | string => {
      if (!value || value.length < NAME_MIN_LENGTH) {
        return minLengthMessage;
      }

      return true;
    },
  };
}
